import React from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import { withStyles } from "@material-ui/core/styles";
import L from "leaflet";
import HeatmapOverlay from "heatmap.js/plugins/leaflet-heatmap";
import { } from "leaflet.markercluster"
import "./MarkerCluster.css";
import "./MarkerCluster.Default.css";
import "./CampaignDetailPage.css";
import { translate } from "react-i18next";
import { devIcon } from "../_assets";
const styles = theme => ({
    // map: { height: "100%" }
});
let boundFlag = 0
class Maps extends React.Component {
    constructor() {
        super();
        this.markers=[]
        this.markerGroup= L.markerClusterGroup({
            maxClusterRadius:30,
            animate:false,
            showCoverageOnHover: false,
            removeOutsideVisibleBounds: true,
        })
        this.heatmapLayer = new HeatmapOverlay({
            // radius should be small ONLY if scaleRadius is true (or small radius is intended)
            radius: 20,
            max: 5,
            // scales the radius based on map zoom
            scaleRadius: false,
            // if set to false the heatmap uses the global maximum for colorization
            // if activated: uses the data maximum within the current map boundaries
            //   (there will always be a red spot with useLocalExtremas true)
            useLocalExtrema: true,
            // which field name in your data represents the latitude - default "lat"
            latField: "lat",
            // which field name in your data represents the longitude - default "lng"
            lngField: "lng",
            // which field name in your data represents the data value - default "value"
            valueField: "count",
            // backgroundColor to cover transparent areas
            // backgroundColor: 'rgba(0,0,0,.5)',
            // custom gradient colors
            gradient: {
                // enter n keys between 0 and 1 here
                // for gradient color customization
                "0.1": "blue",
                "0.25": "cyan",
                "0.4": "green",
                "0.55": "yellow",
                "0.7": "orange",
                "0.95": "red"
            },
            // the maximum opacity (the value with the highest intensity will have it)
            maxOpacity: 0.75,
            // minimum opacity. any value > 0 will produce
            // no transparent gradient transition
            minOpacity: 0.25,
            // onExtremaChange will be called whenever there's a new maximum or minimum
            onExtremaChange: function(data) {
                // updateLegend(data);
            }
        });
    }
    //old dif new =remove 
    //new dif old =add
    componentWillReceiveProps(nextProps){
        this.markers=[]
        this.markerGroup.clearLayers()
        if(nextProps.devs &&nextProps.devs.devs &&nextProps.devs.devs.data){
            let devs=nextProps.devs.devs
            if(devs.id == nextProps.campId){
                for (var i =0;i<devs.data.length;i++){
                    let marker=L.marker([devs.data[i].lat,devs.data[i].long],{icon:devIcon})
                    this.markers.push(marker)
                }
                this.markerGroup.addLayers(this.markers)
            }
        }
    }
    componentDidMount() {
        var map = (this.map = L.map(ReactDOM.findDOMNode(this), {
            layers: [
                L.tileLayer(
                    "https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png",
                    {
                        attribution:
                            '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
                        minZoom: 3,
                        maxZoom: 18
                    }
                ),
                this.markerGroup,
                this.heatmapLayer
            ],
            attributionControl: false
        }));

        map.on("click", this.onMapClick.bind(this));
        map.on("zoomend", this.logZoom.bind(this));
        map.on("mousemove", e => this.onMouseMove(e, map));

        this.boundVN(map);
    }

    onMapClick() {}

    logZoom() {
        // this.map && console.log("zoom = ", this.map.getZoom());
    }

    onMouseMove(e, map) {
        // let value = this.heatmapLayer._heatmap.getValueAt({
        //     x: e.containerPoint.x,
        //     y: e.containerPoint.y
        // });
        // 
        //
        // if (value > 0) {
        //     var popLocation = e.latlng;
        //     L.popup()
        //         .setLatLng(popLocation)
        //         .setContent(`<p>${value}</p>`)
        //         .openOn(map);
        // }
    }

    componentWillUnmount() {
        this.map.off("click", this.onMapClick.bind(this));
        this.map.off("zoomend", this.logZoom.bind(this));
        this.map = null;
        this.markers=[]
        this.markerGroup.clearLayers()
    }

    boundVN(map) {
        const VN = { W: 23.475705, N: 101.781549, S: 104.958643, E: 10.290826 };
        map.fitBounds(
            [[VN.W, VN.N], [VN.E, VN.N], [VN.E, VN.S], [VN.W, VN.S]],
            { padding: [0, 0] }
        );
    }

    render() {
        const { heatmap, classes } = this.props;
        if (
            heatmap.items &&
            heatmap.items.data &&
            heatmap.items.data.length > 0
        ) {
            // Set data
            this.heatmapLayer.setData({
                max: 20,
                data: heatmap.items.data
            });

            // Bound
            if(boundFlag==0){
                let points = heatmap.items.data.map(({ lat, lng }) => [lat, lng]);
                this.map && this.map.fitBounds(points);
                boundFlag=1
            }
        } else {
            // Set data
            this.heatmapLayer.setData({
                max: 20,
                data: {}
            });

            // Bound
            // this.map && this.boundVN(this.map);
        }
        return <div className={classes.map} />;
    }
}

function mapStateToProps(state) {
    const { devs,heatmap } = state;
    return {
        heatmap,
        devs
    };
}

const connectedMaps = connect(mapStateToProps)(Maps);

export default withStyles(styles)(translate("translations")(connectedMaps));



// WEBPACK FOOTER //
// ./src/CampaignDetailPage/Maps.js